import React from "react";
import { useTranslation } from "react-i18next";
import AccordionBox from "components/Layouts/AccordionBox";
import SimpleDataTable from "components/Modules/SimpleDataTable";

const KeyContacts = ({ contactsList, isLoading }) => {
	const { t } = useTranslation();
	return (
		<AccordionBox
			title={t("title.keyContacts")}
			accordianDetailsCss="siteDetailTableContainer"
		>
			<SimpleDataTable
				isLoading={isLoading}
				data={contactsList}
				tableHeaders={[t("label.name"), t("label.application"), t("label.email")]}
			/>
		</AccordionBox>
	);
};

export default KeyContacts;
